export const NEW_CAMERAS_PLATFORM_MODAL_DISMISSED_KEY =
  "newCamerasPlatformModalDismissed";

export const getNewCamerasPlatformModalDismissedKey = (
  salesforceContactId: string
): string =>
  `${NEW_CAMERAS_PLATFORM_MODAL_DISMISSED_KEY}:${salesforceContactId}`;

export const RAM_LIVE_VISIBLE_FEATURE_FLAG = "RAM_LIVE_VISIBLE";

export interface NewCamerasPlatformModalProps {
  open: boolean;
  salesforceId: string;
  salesforceContactId: string;
  onClose: () => void;
}
